module.exports = __webpack_public_path__ + "static/media/warning.d906d283.svg";